<template>
	<app-modal
		v-if="canEditExtraDeliveryTime()"
		:title="`${$t('extraDeliveryTitle')}: ${business.restaurantName}`"
		@close="$emit('close')"
	>
		<div>
			<app-select
				:options="delayOptions"
				class="w-32 mb-4"
				:placeholder="`${$t('delay')}`"
				:can-deselect="false"
				v-model="extraTime"
			/>
			<app-select
				:options="durationOptions"
				class="w-32 mb-4"
				:placeholder="`${$t('duration')}`"
				:can-deselect="false"
				v-model="durationOfDelay"
			/>
		</div>
		<div class="flex gap-2">
			<app-button class="btn btn-success w-full wt-2" @click="saveExtraDeliveryTime" type="submit">{{
				$t('save')
			}}</app-button>
			<app-button
				v-if="business.extraDeliveryTime.extraTime"
				class="btn btn-primary w-full wt-2"
				@click="deleteExtraDeliveryTime"
				type="submit"
				>{{ $t('delete') }}</app-button
			>
		</div>
	</app-modal>
</template>

<script>
	import AppModal from '@/components/app/AppModal.vue';
	import AppSelect from '@/components/app/AppSelect.vue';
	import AppButton from '@/components/app/AppButton.vue';
	import moment from 'moment/moment';
	import OrderService from '@/services/OrderService';
	import { mapGetters } from 'vuex';
	import BusinessService from '@/services/sales/BusinessService';

	export default {
		name: 'ExtraDeliveryTimeModal',
		components: { AppButton, AppSelect, AppModal },
		props: ['business'],
		computed: {
			...mapGetters({
				user: 'user',
			}),
		},
		data: () => ({
			extraTime: 0,
			durationOfDelay: 0,
			durationOptions: [
				{ label: '30m', value: 30 },
				{ label: '1h', value: 60 },
				{ label: '1h 30m', value: 90 },
				{ label: '2h', value: 120 },
				{ label: '2h 30m', value: 150 },
				{ label: '3h', value: 180 },
			],
			delayOptions: [
				{ label: '5m', value: 5 },
				{ label: '10m', value: 10 },
				{ label: '15m', value: 15 },
				{ label: '20m', value: 20 },
				{ label: '25m', value: 25 },
				{ label: '30m', value: 30 },
				{ label: '35m', value: 35 },
				{ label: '40m', value: 40 },
				{ label: '45m', value: 45 },
				{ label: '50m', value: 50 },
				{ label: '55m', value: 55 },
				{ label: '1h', value: 60 },
			],
		}),
		methods: {
			canEditExtraDeliveryTime() {
				return BusinessService.canEditExtraDeliveryTime();
			},
			saveExtraDeliveryTime() {
				this.emitter.emit('isLoading', true);
				let payload = {
					startDate: moment().format('YYYY-MM-DD HH:mm:ss'),
					endDate:
						this.durationOfDelay > 0
							? moment()
									.add(this.durationOfDelay, 'minutes')
									.format('YYYY-MM-DD HH:mm:ss')
							: this.business.extraDeliveryTime.endDate,
					extraTime: this.extraTime,
				};
				OrderService.saveExtraDeliveryTime(payload, this.business.restaurantID)
					.then(() => {
						this.$notificationService.success('Success!');
						let index = this.user.restaurants.findIndex(
							(res) => res.restaurantID === this.business.restaurantID
						);
						payload.index = index;
						this.$store.commit('SET_RESTAURANT_EXTRA_DELIVERY_TIME', payload);
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.$emit('close');
						this.emitter.emit('isLoading', false);
					});
			},
			deleteExtraDeliveryTime() {
				this.emitter.emit('isLoading', true);
				let payload = {
					startDate: moment().format('YYYY-MM-DD HH:mm:ss'),
					endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
					extraTime: 0,
				};
				OrderService.deleteExtraDeliveryTime(this.business.restaurantID, 0)
					.then(() => {
						this.$notificationService.success('Success!');
						let index = this.user.restaurants.findIndex(
							(res) => res.restaurantID === this.business.restaurantID
						);
						payload.index = index;
						this.$store.commit('SET_RESTAURANT_EXTRA_DELIVERY_TIME', payload);
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.$emit('close');
						this.emitter.emit('isLoading', false);
					});
			},
			calculateDelayAndDuration() {
				let duration = moment
					.duration(
						moment(this.business.extraDeliveryTime.endDate).diff(
							moment(this.business.extraDeliveryTime.startDate)
						)
					)
					.asMinutes();
				this.durationOfDelay = duration;
				this.extraTime = this.business.extraDeliveryTime.extraTime;
			},
		},
		mounted() {
			this.calculateDelayAndDuration();
		},
	};
</script>

<style scoped></style>
